import React from "react";
import { useState,useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/PaymentsComparisonReport.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Loading from './Loading';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { format } from "date-fns";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';


const columns = [
    {
        field: 'name',
        headerName: 'Name',  
        headerClassName:'name_header',    
        flex:1,
        minWidth: 100,
        sortable:false,
    },
    {
        field: 'mail',
        headerName: 'Mail',
        cellClassName:'mail_column',headerClassName:'mail_header',   
        flex:1, 
        minWidth: 250,
        sortable:false,
    },
    {
        field: 'salesperson',
        headerName: 'Salesperson',
        headerClassName:'salesperson_header',   
        flex:1,
        minWidth: 93,
        sortable:false,
    },
    {
        field: 'order_id',
        headerName: 'Order id',
        cellClassName:'order_id_column',headerClassName:'order_id_header',  
        flex:1, 
        minWidth: 57, 
        sortable:false,
    },
    {
        field: 'product',
        headerName: 'Product Purchased',   
        headerClassName:'product_purchased_header',
        flex:1,
        minWidth: 320,
        sortable:false,
    },
    {
        field: 'amount_paid',
        headerName: 'Amount',   
        headerClassName:'amount_header',
        flex:1,
        minWidth: 170,
        sortable:false,
    }
];

const PaymentsComparisonReport = () => {

    // const formatMMDDYY = (date) => {
    //     const mm = String(date.getMonth() + 1).padStart(2, '0');
    //     const dd = String(date.getDate()).padStart(2, '0');
    //     const yy = String(date.getFullYear()).slice(-2);
    //     return `${mm}/${dd}/${yy}`;
    // };

    const getStartAndCurrentDates = () => {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        return {
            start: firstDay,
            end: now,
        };
    };

    const initialDates = getStartAndCurrentDates();

    const formatISODate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };

    // const getStartAndCurrentDatesFormatted = () => {
    //     const now = new Date();
    //     const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    //     const currentDay = now;
    //     return {
    //         start: formatISODate(firstDay),
    //         end: formatISODate(currentDay),
    //     };
    // };

    // const initialDates = getStartAndCurrentDatesFormatted();

    // const handleStartDateChange = (date) => {
           
    //       const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
    //         setFormData(prev => ({ ...prev, start_date: formattedDate }));
    //       };
    //       const handleEndDateChange = (date) => {
           
    //       const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
    //           setFormData(prev => ({ ...prev, end_date: formattedDate }));
    //       };


    const handleDateChange = (date, field) => {
    setFormData(prev => ({
        ...prev,
        [`${field}_obj`]: date,                   
        [field]: date ? format(date, 'yyyy-MM-dd') : '' 
    }));
    };

 const [checked, setChecked] = React.useState(true);

  const initialPaymentsComparisonForm = () => {
  const params = new URLSearchParams(window.location.search);

    const defaultForm = {
            type:'month',
            courses:[],
            salesperson:'',
            start_date: formatISODate(initialDates.start),
            start_date_obj: initialDates.start,
            end_date: formatISODate(initialDates.end),
            end_date_obj: initialDates.end,
            compare:checked,
            action:''
        };

  const queryStart = params.get("start_date");
  const queryEnd = params.get("end_date");

  //  Safe date parsing (Safari friendly)
  const startObj = queryStart
    ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
    : defaultForm.start_date_obj;

  const endObj = queryEnd
    ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
    : defaultForm.end_date_obj;

  //  Courses parsing (supports both formats)
//   const courses = (() => {
//     if (!params.has("courses")) return defaultForm.courses;

//     const allCourses = params.getAll("courses");

//     if (allCourses.length > 1) {
//       return allCourses.filter(Boolean);
//     }

//     if (allCourses.length === 1) {
//       if (!allCourses[0]) return [];
//       return allCourses[0].split(",").filter(Boolean);
//     }

//     return [];
//   })();
    const courses = (() => {
    const values = [];

    for (const [key, value] of params.entries()) {
        if (key.startsWith("courses[")) {
        if (value) values.push(value);
        }
    }

    return values;
    })();

  return {
    ...defaultForm,

    //  keep default if no query
    start_date: queryStart || defaultForm.start_date,
    start_date_obj: startObj,

    end_date: queryEnd || defaultForm.end_date,
    end_date_obj: endObj,

    //include type from query
    type: params.get("type") || defaultForm.type,

    salesperson: params.get("salesperson") || defaultForm.salesperson,

    courses: courses,

  //  view: params.get("view") || defaultForm.view,

    action: params.get("action") || defaultForm.action
  };
};

    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialPaymentsComparisonForm());
    // const [appliedFormData, setAppliedFormData] = useState(initialPaymentsComparisonForm);
    const [isFilterReady, setIsFilterReady] = useState(false);
    const [submittedData, setSubmittedData] = useState(initialPaymentsComparisonForm());
    const [formErrors, setFormErrors] =useState({});
    const[salespersonList, setSalespersonList] = useState({});
    const[courseList, setCourseList] = useState({});
    const[reportdetails, setReportDetails] = useState({});
     const[headerdetails, setHeaderDetails] = useState({});
     const[selectedreportdetails, setSelectedReportDetails] = useState({});
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
     const [totalamount, setTotalAmount] = useState('');
     const [showtable, setShowTable] = useState(false);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [graphCategories, setGraphCategories] = React.useState([]);
     const [graphData, setGraphData] = React.useState([]);
    
    const [filterModel, setFilterModel] = React.useState({ items: [] });

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleCoursesChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, courses: selectedValues }));
    };
     const showSelectedData = (e) => {
       setShowTable(!showtable);
    };
    const app_url = configData.APP_URL;
const formatDate = (dateStr) => {
  const date = new Date(dateStr);

  const month = date.getMonth() + 1; // 0-based
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

    const options = {
        chart: {
            type: 'column'
        },
        title: {
            text: `DATE RANGE: ${formatDate(submittedData.start_date)} - ${formatDate(submittedData.end_date)}`
        },
        xAxis: {
            categories: graphCategories,
        },
        yAxis: {
            min: 0,
            title: {
                text: ''
            }
        },
        series: [{
            name:'Sale',
            data: graphData.map(Number)
        }]
    }
//         // Validation function
// const validateDates = (formData) => {
//   let errors = {};

//   if (!formData.start_date) {
//     errors.start_date = "Start date is required.";
//   }

//   if (!formData.end_date) {
//     errors.end_date = "End date is required.";
//   }

//   if (formData.start_date && formData.end_date) {
//     if (formData.end_date < formData.start_date) {
//       errors.end_date = "Start date can't over end date.";
//     }
//   }

//   return errors;
// };

    // Validation function
    const validateDates = (formData) => {
        let errors = {};

        if (!formData.start_date) {
            errors.start_date = "Start date is required.";
        }

        if (!formData.end_date) {
            errors.end_date = "End date is required.";
        }

        if (formData.start_date && formData.end_date) {
            const startDate = new Date(formData.start_date);
            const endDate = new Date(formData.end_date);

            if (endDate < startDate) {
            errors.end_date = "Start date can't over end date.";
            }
        }

        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => { 
         Promise.all([
          getsalespersonlist(),
            getcourselist()
          
          ]).then(() => {
     
            
          })
      
        
    },[]); 

    async function getsalespersonlist() {
        try {
            const response = await fetch(
                app_url+'user/getsalespersonlistwithunassigned',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }    
    }
    async function getcourselist() {
        try {
            const response = await fetch(
                app_url+'paymentcomparisonreport/getproductlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCourseList(responsedata.data.result);
                
               
            } 
        } catch (err) {
            
        }    
    }
     React.useEffect(() => {

        if (!submittedData || !isFilterReady) return;
         
              const fetchData = async () => {
              // Simulate API call to your server
               try {
                setIsLoading(true);
              const response = await fetch(app_url+'paymentcomparisonreport/getlist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                 
                  //formData:formData
                    formData: {
                        ...formData,
                        action: isSubmitted ? 'submit' : ''
                    }
                }),
              });
              const data = await response.json();
             if(data.data.msg == "Success") {
                setReportDetails(data.data.result);
                setHeaderDetails(data.data.header_array);
                setRows(data.data.rows);
                setRowCount(data.data.totalRowCount);
                setTotalAmount(data.data.overall_total);
                setGraphCategories(data.data.graph_category);
                setGraphData(data.data.graph_data);
             }
              }  catch (error) {
                    console.error('Error fetching data:', error);
                  } finally {
                    setIsLoading(false); // Set loading to false after fetch completes (success or error)
                     if (isSubmitted) {
                   setIsSubmitted(false);
                    }
                  }
                  
            };
            
        
            fetchData();
         
              }, [submittedData, isFilterReady]); // Re-fetch data when these change

  // Handle submit
    const handleSubmit = async (e) => {
    e.preventDefault();

    const { type } = formData;
    let updatedData = { ...formData };
     const errors = validateDates(updatedData);
    if (Object.keys(errors).length > 0) {
        console.log("Validation errors:", errors);
        setFormErrors(errors);
        return;
    }
    

    if (type === 'year') {
        const currentYear = moment().year();
        // updatedData.start_date = updatedData.start_date || moment()
        //   .tz('America/Los_Angeles')
        //   .year(currentYear)
        //   .startOf('year')
        //   .format('YYYY-MM-DD');
        
        // updatedData.end_date = updatedData.end_date || moment()
        //   .tz('America/Los_Angeles')
        //   .format('YYYY-MM-DD');

            updatedData.start_date = moment().tz('America/Los_Angeles').year(currentYear).startOf('year').format('YYYY-MM-DD');
            updatedData.end_date = moment.tz(new Date(), 'America/Los_Angeles').format('YYYY-MM-DD');
    } else if (type === 'month') {
        updatedData.start_date = updatedData.start_date || moment()
        .tz('America/Los_Angeles')
        .startOf('month')
        .format('YYYY-MM-DD');
    }   

    setFormErrors({});
    setSubmittedData(updatedData);
    setShowTable(false);
     setIsSubmitted(true);

    // try {
    //     setIsLoading(true);
    //     const response = await fetch(app_url + 'paymentcomparisonreport/getlist', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ formData: updatedData }),
    //     });
    //     const data = await response.json();

    //     if (data.data.msg === "Success") {
    //     setReportDetails(data.data.result);
    //     setHeaderDetails(data.data.header_array);
    //     setRows(data.data.rows);
    //     setRowCount(data.data.totalRowCount);
    //     setTotalAmount(data.data.overall_total);
    //     setGraphCategories(data.data.graph_category);
    //     setGraphData(data.data.graph_data);
    //     }
    // } catch (error) {
    //     console.error('Error fetching data:', error);
    // } finally {
    //     setIsLoading(false);
    // }

    console.log("Form submitted:", updatedData);

    if (updatedData.type !== 'month') {
        setShowSuccessMessage(true);
    } else {
        setShowSuccessMessage(false);
    }
    };

  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
    let updatedData = { ...submittedData };
    const errors = validateDates(updatedData);

    if (Object.keys(errors).length > 0) {
        console.log("Validation errors:", errors);
        setFormErrors(errors); 
        return;
    }
    setFormErrors({});
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'paymentcomparisonreport/getexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:updatedData
        }),
      });
      const data = await response.json();
      const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
   const submitFormData = async (data) => {
        setSubmittedData(data);
        setFormData(data);
        setIsSubmitted(false);
        
    if (data.type !== 'month') {
        setShowSuccessMessage(true);
    } else {
        setShowSuccessMessage(false);
    }
      };
      
    //   useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);
      
    //     if ([...params.keys()].length > 0) {
    //       const init = initialPaymentsComparisonForm();
      
    //       setFormData(init);
      
    //       submitFormData(init);              
    //     }
    //   }, []);
        const normalizeBackendData = (backendParams) => {
          return {
            ...backendParams,
        
            start_date_obj: backendParams.start_date
              ? new Date(backendParams.start_date.replace(/-/g, "/") + " 00:00:00")
              : null,
        
            end_date_obj: backendParams.end_date
              ? new Date(backendParams.end_date.replace(/-/g, "/") + " 00:00:00")
              : null,
          };
        };
        
        useEffect(() => {
          const params = new URLSearchParams(window.location.search);
          const reportViewId = params.get("report_view_id");
        
          const baseForm = initialPaymentsComparisonForm(); 
        
          if (reportViewId) {
            const fetchData = async () => {
              try {
                const res = await fetch(app_url + 'report/getreportfilters', {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ id: reportViewId }),
                });
        
                const data = await res.json();
                const backendParams = data?.data?.params || {};
        
                //  normalize backend
                const normalized = normalizeBackendData(backendParams);
        
                //  merge (backend overrides URL/defaults)
                const finalData = {
                  ...baseForm,
                  ...normalized,
                };
        
                setFormData(finalData);
                submitFormData(finalData);
                setIsFilterReady(true);
        
              } catch (err) {
                console.error(err);
              }
            };
        
            fetchData();
          } else {
            //  fallback → only URL/default
            // if ([...params.keys()].length > 0) {
              setFormData(baseForm);
              submitFormData(baseForm);
              setIsFilterReady(true);
            // }
          }
        
        }, []);
  
   
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main ">
                    <Helmet><title>Payments Comparison Report</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        
                        <div className="payments-comparison-report-container">
                            <div className="payment-comparison-report-first-container">
                                <h1>Payments Comparison Report</h1>
                            <div className="messages warning">
                                <p><strong>This report includes:</strong></p>

                                <p>&nbsp;&nbsp;- This report only includes Courses Payments, it does not include courses payments that were collected as "Miscellaneous Charges".</p>
                                <p>&nbsp;&nbsp;- Data available starting May 2003</p>
                                
                                <p>&nbsp;&nbsp;- If you're looking up large amounts of data, please wait for the report to load.</p>
                                
                                <p>&nbsp;&nbsp;- If your search is not successful (i.e. system crashes), try narrowing the search.</p>
                            </div>
                            <form>
                                <fieldset>
                                    <legend> Filter </legend>
                                    <div style={{paddingLeft: "30px"}}>
                                        <select style={{width:"16%"}} id="type" name="type" className="form-select" onChange={handleChange} value={formData.type}>
                                            <option value="month">By month</option>
                                            <option value="year">By Year</option>
                                        </select>
                                    </div>
                                    <div className="payments-comparison-flex">
                                        <div>
                                            <select 
                                            name="courses" 
                                                        size="15" 
                                                        className="form-select"
                                                        multiple
                                                        onChange={handleCoursesChange}
                                                        value={formData.courses}
                                            >

                                                { Object.keys(courseList).length > 0 && (
                                                    <>
                                                        { Object.keys(courseList).map((key) => {
                                                            return <>
                                                              
                                                                    <option value={key}>{courseList[key]}</option>
                                                                
                                                            </>
                                                        })}  
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div>
                                            <label>Salesperson:</label>
                                            <select 
                                                id="salesperson" 
                                                name="salesperson" 
                                                style={{width:"300px",border:"1px solid #ccc",padding: "2px"}}
                                                onChange={handleChange}
                                                value={formData.salesperson}
                                            >
                                                <option value="ALL">ALL</option>
                                                {salespersonList.length > 0 && (
                                                    <>
                                                        {salespersonList.map((item, index) => {
                                                            return <>
                                                                {item['uid'] != null && (
                                                                    <><option value={item['uid']}>{item['name']}</option></>
                                                                )}
                                                            </>
                                                        })}  
                                                    </>
                                                )}
                                               
                                            </select><br /><br />
                                            {showSuccessMessage ? (
                                                <div className="messages status" style={{width: "300px",background: `#f8fff0 url("/basic/web/images/message-ok.png") no-repeat`,backgroundPosition: '10px 10px'}}>
                                                    <p>This report is used to compare the sales per year.</p>
                                                    <p>For the current year, this report generates the results from Jan 01 to date.</p> 
                                                    <p>For past years it generates the results for the whole year (January 01 to December 31).</p>
                                                </div>
                                            ) : (
                                            <div>
                                                <label htmlFor="rangeBa">Start Date:</label>
                                            
                                                <DatePicker
                                                    ref={startDateRef}
                                                    // selected={formData.start_date}
                                                    selected={formData.start_date_obj}
                                                    //onChange={(date) => setFormData({ ...formData, start_date: date })}
                                                    id="start_date"
                                                    name="start_date" 
                                                    onChange={(date) => {
                                                        handleDateChange(date, "start_date");
                                                        setTimeout(() => {
                                                            const input = startDateRef.current?.input;
                                                            if (input) {
                                                            const len = input.value.length;
                                                            input.setSelectionRange(len, len);
                                                            }
                                                        }, 0);
                                                    }}
                                                    className=""
                                                    style={{width:"300px",border:"1px solid #ccc",padding: "2px"}} 
                                                /> 
                                                    {formErrors.start_date && (
                                                        <div className="error">{formErrors.start_date}</div>
                                                        )}  
                                                <br /><br />
                                                <label htmlFor="rangeBb">End Date:</label>
                                        
                                                <DatePicker
                                                    // selected={formData.end_date}
                                                    ref={endDateRef}
                                                    selected={formData.end_date_obj}
                                                    // onChange={handleEndDateChange}
                                                    onChange={(date) => {
                                                        handleDateChange(date, "end_date");
                                                        setTimeout(() => {
                                                            const input = endDateRef.current?.input;
                                                            if (input) {
                                                            const len = input.value.length;
                                                            input.setSelectionRange(len, len);
                                                            }
                                                        }, 0);
                                                    }}
                                                    id="end_date"
                                                    name="end_date"
                                                    className=""
                                                    style={{width:"300px",border:"1px solid #ccc",padding: "2px"}} 
                                                /> 
                                                {formErrors.end_date && (
                                                    <div className="error">{formErrors.end_date}</div>
                                                )}
                                                <br /><br />
                                                <div className="compare-main-container" style={{backgroundColor:"red",width:"150px",color: "#ffff"}}>
                                                    <label className="compare-container">
                                                        <span>Compare</span>
                                                        <input 
                                                            name="compare" 
                                                            id="compare" 
                                                            type="checkbox" 
                                                            checked={checked}
                                                        onChange={() => {
                                                                setChecked(!checked);
                                                                setFormData(prev => ({ ...prev, compare: !checked }));
                                                            }}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>	
                                            </div>	
                                            )}	
                                        </div>
                                        <div>
                                            <input type="submit" name="" value="submit" className="form-submit" onClick={handleSubmit}/> 
                                            <input type="submit" name="" value="export" className="form-submit"onClick={handleExport} />
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                            <div className="dp-style">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="panel panel-default">
                                            <div className="panel-body">
                                                <HighchartsReact
                                                    highcharts={Highcharts}
                                                    options={options}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-4 sales-small-box comparison-bg">
                                        <div className="inner">
                                            <div className="chart_heading" style={{textAlign:"center"}}>Total Sales between <br />{formatDate(submittedData.start_date)} to {formatDate(submittedData.end_date)}</div>
                                            <h3>{totalamount}</h3>  
                                        </div>	
                                    </div>
                                </div>
                            </div>
                           {showtable && (
                            <div className="total-sales-popupdata">
                                <div className="total-sales-content">
                                    <div>
                                            <DataGrid
                                                autoHeight
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                // disableColumnResize={true}
                                            />
                                        </div>
                                </div>
                            </div>
                           )}
                            </div>
                            <div className="page-view-myorder">
                                <div className="sales-comparison-content">
                                    <table className="sales-comparison-table">
                                        <tbody>
                                            
                                      {headerdetails.length > 0 && (
                                        <><tr>
                                        {headerdetails.map((item, index) => (

                                            <th key={index} style={{background: index % 2 === 0 ? '#b8d1f3' : '#dae5f4'}} colSpan={index === 0 ? 1 : 4}>
                                                {item.name}
                                            </th>
                                        ))}
                                        </tr></>
                                        )}
                                          {headerdetails.length > 0 && (
                                        <><tr>
                                        {headerdetails.map((item, index) => (
                                            index == 0 ? (
                                                <><th style={{background: index % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}></th></>
                                            ) :(
                                            <>
                                            <th style={{background: index % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}>Total Apps</th>
                                            <th style={{background: index % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}>Full App</th>
                                            <th style={{background: index % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}>Pre Apps</th>
                                            <th style={{background: index % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}>Amount</th></>
                                            )
                                           
                                            
                                        ))}
                                        </tr></>
                                        )}
                                        
                                        {Object.keys(reportdetails).length > 0 && (
                                        <>
                                       
                                            {Object.keys(reportdetails).map((key,index) => (
                                                
                                                <><tr>
                                                    <td style={{background: '#b8d1f3'}}>
                                                        {index == 0 ? (
                                                            <><a style={{cursor:'pointer'}} href onClick={showSelectedData}>{key}</a></> 
                                                        ) : (
                                                           <>{key}</> 
                                                        )
                                                        
                                                        }
                                                        
                                                        </td>
                                                    {headerdetails.length > 0 && (
                                                    
                                                    headerdetails.map((item, cindex) => (
                                                    cindex == 0 ? (
                                                        <> <td style={{background:'#dae5f4'}}>{reportdetails[key]['total']['apptotal']}</td>
                                                        <td style={{background:'#dae5f4'}}>{reportdetails[key]['total']['Fullapptotal']}</td>
                                                        <td style={{background:'#dae5f4'}}>{reportdetails[key]['total']['Preapptotal']}</td>
                                                        <td style={{background:'#dae5f4'}}>{reportdetails[key]['total']['payments']}</td>
                                                        </>
                                                    ) :(
                                                        item['key'] && (
                                                        <>
                                                        <td style={{background: cindex % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}>{reportdetails[key][item['key']]['apptotal']}</td>
                                                        <td style={{background: cindex % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}>{reportdetails[key][item['key']]['Fullapptotal']}</td>
                                                        <td style={{background: cindex % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}>{reportdetails[key][item['key']]['Preapptotal']}</td>
                                                        <td style={{background: cindex % 2 === 0 ? '#b8d1f3' : '#dae5f4'}}>{reportdetails[key][item['key']]['payments']}</td></>
                                                         ) )
                                                ))
                                        
                                                 )}
                                                    </tr></>
                                            ))}
                                           
                                        </>
                                        )}  
                                        </tbody> 
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};
export default PaymentsComparisonReport;